export const getAllAmbulanceEmployeeSuccess = 'GET_ALL_AMBULANCE_EMPLOYEE_SUCCESS';
export const getAllAmbulanceEmployeeFailure = 'GET_ALL_AMBULANCE_EMPLOYEE_FAILURE';

export const addAmbulanceEmployeeSuccess = "ADD_AMBULANCE_EMPLOYEE_SUCCESS";
export const addAmbulanceEmployeeFailure = "ADD_AMBULANCE_EMPLOYEE_FAILURE";

export const editAmbulanceEmployeeSuccess = "EDIT_AMBULANCE_EMPLOYEE_SUCCESS";
export const editAmbulanceEmployeeFailure = "EDIT_AMBULANCE_EMPLOYEE_FAILURE";

export const deleteAmbulanceEmployeeSuccess = "DELETE_AMBULANCE_EMPLOYEE_SUCCESS";
export const deleteAmbulanceEmployeeFailure = "DELETE_AMBULANCE_EMPLOYEE_FAILURE";

